module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.errorMessage) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_c('strong', {
    staticClass: "text-uppercase"
  }, [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e(), _vm._v(" "), (_vm.successMessage) ? _c('div', {
    staticClass: "alert alert-success"
  }, [_c('strong', {
    staticClass: "text-uppercase"
  }, [_vm._v(_vm._s(_vm.successMessage))])]) : _vm._e(), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.preSave($event)
      }
    }
  }, [_c('div', {
    staticClass: "panel panel-custom"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body",
    staticStyle: {
      "padding-bottom": "5px"
    }
  }, [_c('v-input', {
    attrs: {
      "label": "NOME",
      "maxlength": "200",
      "error-message": _vm.validate('isNotBlank', _vm.form.nome, 'Preenchimento obrigatório')
    },
    on: {
      "keypress": _vm.preventNumbers
    },
    model: {
      value: (_vm.form.nome),
      callback: function($$v) {
        _vm.form.nome = $$v
      },
      expression: "form.nome"
    }
  }), _vm._v(" "), _c('v-input', {
    attrs: {
      "type": "tel",
      "label": "DATA DE NASCIMENTO",
      "placeholder": "DD/MM/AAAA",
      "mask": {
        format: '99/99/9999',
        change: true
      },
      "error-message": _vm.form.dataNascimento !== '' ? _vm.validate('isValidDate', _vm.form.dataNascimento, 'Data inválida') : ''
    },
    model: {
      value: (_vm.form.dataNascimento),
      callback: function($$v) {
        _vm.form.dataNascimento = $$v
      },
      expression: "form.dataNascimento"
    }
  }), _vm._v(" "), _c('v-input', {
    attrs: {
      "type": "tel",
      "label": "CPF",
      "mask": {
        format: '99999999999'
      },
      "error-message": _vm.validate('isValidCPF', _vm.form.cpf, 'CPF inválido') || _vm.invalidCPF
    },
    on: {
      "input": function($event) {
        _vm.checkCPF(_vm.form.cpf)
      }
    },
    model: {
      value: (_vm.form.cpf),
      callback: function($$v) {
        _vm.form.cpf = $$v
      },
      expression: "form.cpf"
    }
  }), _vm._v(" "), _c('v-input', {
    attrs: {
      "label": "RG",
      "maxlength": "15",
      "error-message": _vm.validate('isNotBlank', _vm.form.rg, 'Preenchimento obrigatório')
    },
    model: {
      value: (_vm.form.rg),
      callback: function($$v) {
        _vm.form.rg = $$v
      },
      expression: "form.rg"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-custom"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "panel-body",
    staticStyle: {
      "padding-bottom": "5px"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("ENDEREÇO COM CEP?")]), _vm._v(" "), _c('p', {
    staticClass: "form-control-static"
  }, [_c('v-radio', {
    attrs: {
      "option-text": "SIM",
      "option-value": true
    },
    model: {
      value: (_vm.form.enderecoNormalizado),
      callback: function($$v) {
        _vm.form.enderecoNormalizado = $$v
      },
      expression: "form.enderecoNormalizado"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "option-text": "NÃO",
      "option-value": false
    },
    model: {
      value: (_vm.form.enderecoNormalizado),
      callback: function($$v) {
        _vm.form.enderecoNormalizado = $$v
      },
      expression: "form.enderecoNormalizado"
    }
  })], 1)]), _vm._v(" "), (_vm.form.enderecoNormalizado) ? _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.invalidCep || (_vm.validating && _vm.form.enderecoCep.idCep.length < 8)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "cep"
    }
  }, [_vm._v("CEP")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.buscarCEP($event)
      }
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('v-input', {
    attrs: {
      "type": "tel",
      "id": "cep",
      "styles": "border-radius:4px 0 0 4px;",
      "mask": {
        format: '99999-999'
      },
      "wrapped": false
    },
    on: {
      "keyup": function($event) {
        $event.target.value.length === 9 ? _vm.buscarCEP() : ''
      }
    },
    model: {
      value: (_vm.form.enderecoCep.idCep),
      callback: function($$v) {
        _vm.form.enderecoCep.idCep = $$v
      },
      expression: "form.enderecoCep.idCep"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-warning",
    attrs: {
      "type": "submit",
      "disabled": _vm.form.enderecoCep.idCep.length < 8
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])], 1)]), _vm._v(" "), (_vm.validate('isValidCEP', _vm.form.enderecoCep.idCep, true)) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("CEP inválido")]) : _vm._e(), _vm._v(" "), (_vm.invalidCep) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("Somente endereços da cidade de Sorocaba são permitidos")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('v-input', {
    attrs: {
      "label": "LOGRADOURO",
      "maxlength": "100",
      "disabled": _vm.form.enderecoNormalizado,
      "error-message": _vm.validate('isNotBlank', _vm.form.enderecoLogradouro, 'Preenchimento obrigatório')
    },
    model: {
      value: (_vm.form.enderecoLogradouro),
      callback: function($$v) {
        _vm.form.enderecoLogradouro = $$v
      },
      expression: "form.enderecoLogradouro"
    }
  }), _vm._v(" "), _c('v-input', {
    attrs: {
      "label": "NÚMERO",
      "maxlength": "10",
      "error-message": _vm.validate('isNotBlank', _vm.form.enderecoNumero, 'Preenchimento obrigatório')
    },
    model: {
      value: (_vm.form.enderecoNumero),
      callback: function($$v) {
        _vm.form.enderecoNumero = $$v
      },
      expression: "form.enderecoNumero"
    }
  }), _vm._v(" "), _c('v-input', {
    attrs: {
      "label": "COMPLEMENTO",
      "maxlength": "100"
    },
    model: {
      value: (_vm.form.enderecoComplemento),
      callback: function($$v) {
        _vm.form.enderecoComplemento = $$v
      },
      expression: "form.enderecoComplemento"
    }
  }), _vm._v(" "), _c('v-input', {
    attrs: {
      "label": "BAIRRO",
      "maxlength": "100",
      "disabled": _vm.form.enderecoNormalizado,
      "error-message": _vm.validate('isNotBlank', _vm.form.enderecoBairro, 'Preenchimento obrigatório')
    },
    model: {
      value: (_vm.form.enderecoBairro),
      callback: function($$v) {
        _vm.form.enderecoBairro = $$v
      },
      expression: "form.enderecoBairro"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('v-input', {
    attrs: {
      "label": "CIDADE",
      "cols": "10",
      "disabled": true
    },
    model: {
      value: (_vm.form.enderecoCep.localidade),
      callback: function($$v) {
        _vm.form.enderecoCep.localidade = $$v
      },
      expression: "form.enderecoCep.localidade"
    }
  }), _vm._v(" "), _c('v-input', {
    attrs: {
      "label": "ESTADO",
      "cols": "2",
      "disabled": true
    },
    model: {
      value: (_vm.form.enderecoCep.ufSigla),
      callback: function($$v) {
        _vm.form.enderecoCep.ufSigla = $$v
      },
      expression: "form.enderecoCep.ufSigla"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-custom"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "panel-body",
    staticStyle: {
      "padding-bottom": "5px"
    }
  }, [_c('v-input', {
    attrs: {
      "type": "tel",
      "label": "TELEFONE FIXO",
      "maxlength": "20",
      "mask": {
        format: '(99) 9999-9999',
        change: true
      },
      "error-message": _vm.form.telefoneFixo === '' ? _vm.validate('isNotBlank', _vm.form.telefoneFixo, 'Preenchimento obrigatório') : _vm.validate('isValidTelephone', _vm.form.telefoneFixo, 'Telefone inválido')
    },
    model: {
      value: (_vm.form.telefoneFixo),
      callback: function($$v) {
        _vm.form.telefoneFixo = $$v
      },
      expression: "form.telefoneFixo"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('v-input', {
    attrs: {
      "type": "tel",
      "label": "TELEFONE CELULAR",
      "maxlength": "20",
      "mask": {
        format: '(99) 99999-9999',
        change: true
      },
      "error-message": _vm.form.telefoneCelular === '' ? _vm.validate('isNotBlank', _vm.form.telefoneCelular, 'Preenchimento obrigatório') : _vm.validate('isValidCelphone', _vm.form.telefoneCelular, 'Telefone inválido')
    },
    model: {
      value: (_vm.form.telefoneCelular),
      callback: function($$v) {
        _vm.form.telefoneCelular = $$v
      },
      expression: "form.telefoneCelular"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.validating && _vm.form.telefoneCelularWhatsapp === ''
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("TEM WHATSAPP?")]), _vm._v(" "), _c('p', {
    staticClass: "form-control-static"
  }, [_c('v-radio', {
    attrs: {
      "option-value": true,
      "option-text": "SIM"
    },
    model: {
      value: (_vm.form.telefoneCelularWhatsapp),
      callback: function($$v) {
        _vm.form.telefoneCelularWhatsapp = $$v
      },
      expression: "form.telefoneCelularWhatsapp"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "option-value": false,
      "option-text": "NÃO"
    },
    model: {
      value: (_vm.form.telefoneCelularWhatsapp),
      callback: function($$v) {
        _vm.form.telefoneCelularWhatsapp = $$v
      },
      expression: "form.telefoneCelularWhatsapp"
    }
  })], 1), _vm._v(" "), (_vm.validating && _vm.form.telefoneCelularWhatsapp === '') ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("Preenchimento obrigatório")]) : _vm._e()])])]), _vm._v(" "), _c('v-input', {
    attrs: {
      "label": "E-MAIL",
      "maxlength": "100",
      "error-message": _vm.form.email !== '' ? _vm.validate('isValidEmail', _vm.form.email, 'E-mail inválido') : ''
    },
    model: {
      value: (_vm.form.email),
      callback: function($$v) {
        _vm.form.email = $$v
      },
      expression: "form.email"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-custom"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "panel-body",
    staticStyle: {
      "padding-bottom": "5px"
    }
  }, [(_vm.updating) ? [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("ALTERAR SENHA?")]), _vm._v(" "), _c('div', [_c('v-radio', {
    attrs: {
      "option-value": true,
      "option-text": "SIM"
    },
    model: {
      value: (_vm.showSenhaFields),
      callback: function($$v) {
        _vm.showSenhaFields = $$v
      },
      expression: "showSenhaFields"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "option-value": false,
      "option-text": "NÃO"
    },
    model: {
      value: (_vm.showSenhaFields),
      callback: function($$v) {
        _vm.showSenhaFields = $$v
      },
      expression: "showSenhaFields"
    }
  })], 1)])] : _vm._e(), _vm._v(" "), (_vm.showSenhaFields) ? [(_vm.updating) ? _c('v-input', {
    attrs: {
      "type": "password",
      "label": "SENHA ATUAL",
      "maxlength": "20",
      "error-message": _vm.validate('hasMinLength', _vm.form.senhaAtual, 5, 'Deve conter ao menos 5 caracteres')
    },
    model: {
      value: (_vm.form.senhaAtual),
      callback: function($$v) {
        _vm.form.senhaAtual = $$v
      },
      expression: "form.senhaAtual"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-input', {
    attrs: {
      "type": "password",
      "label": _vm.updating ? 'NOVA SENHA' : 'SENHA',
      "maxlength": "20",
      "error-message": _vm.validating ?
        _vm.form.senha.length < 5 ?
        'Deve conter ao menos 5 caracteres' :
        _vm.form.senha !== _vm.form.novaSenha ?
        'As senhas não coincidem' :
        '' :
        ''
    },
    model: {
      value: (_vm.form.senha),
      callback: function($$v) {
        _vm.form.senha = $$v
      },
      expression: "form.senha"
    }
  }), _vm._v(" "), _c('v-input', {
    attrs: {
      "type": "password",
      "label": _vm.updating ? 'REPITA A NOVA SENHA' : 'REPITA A SENHA',
      "maxlength": "20",
      "error-message": _vm.validating ?
        _vm.form.novaSenha.length < 5 ?
        'Deve conter ao menos 5 caracteres' :
        _vm.form.senha !== _vm.form.novaSenha ?
        'As senhas não coincidem' :
        '' :
        ''
    },
    model: {
      value: (_vm.form.novaSenha),
      callback: function($$v) {
        _vm.form.novaSenha = $$v
      },
      expression: "form.novaSenha"
    }
  })] : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-custom"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [(_vm.confirming) ? [_c('form', {
    staticClass: "form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.save($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 text-right"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.confirming = false
      }
    }
  }, [_vm._v("NÃO")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("SIM")])])])])] : [_c('button', {
    staticClass: "btn btn-success pull-right",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("SALVAR")])]], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('i', {
    staticClass: "fa fa-user pull-right",
    staticStyle: {
      "margin-top": "5px"
    }
  }), _vm._v(" "), _c('strong', {
    staticClass: "text-uppercase"
  }, [_vm._v("Dados Pessoais")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('i', {
    staticClass: "fa fa-map pull-right",
    staticStyle: {
      "margin-top": "5px"
    }
  }), _vm._v(" "), _c('strong', {
    staticClass: "text-uppercase"
  }, [_vm._v("Endereço")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('i', {
    staticClass: "fa fa-phone pull-right",
    staticStyle: {
      "margin-top": "5px"
    }
  }), _vm._v(" "), _c('strong', {
    staticClass: "text-uppercase"
  }, [_vm._v("Contato")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('i', {
    staticClass: "fa fa-lock pull-right",
    staticStyle: {
      "margin-top": "5px"
    }
  }), _vm._v(" "), _c('strong', {
    staticClass: "text-uppercase"
  }, [_vm._v("Segurança")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-6"
  }, [_c('label', {
    staticClass: "control-label text-uppercase"
  }, [_vm._v("Confirma?")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2ac35142", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ac35142"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./application/views/municipe/form.vue
// module id = 336
// module chunks = 1